<template>
	<MhRouterView class="EditView view maxWidth maxWidth--appBody" :isContentReady="isContentReady">

		<div class="EditView__inner view__inner">

			<DocEditForm></DocEditForm>

		</div>

	</MhRouterView>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js' // TODO: remove this

	import MhRouterView from './../components/MhRouterView/v2/MhRouterView.vue'
	import DocEditForm from './../components/CSGIS/DocEditForm.vue'

	export default {
		name: 'EditView',
		components: {
			MhRouterView,
			DocEditForm,
		},
		mixins: [],
		directives: {},
		props: {},
		data() {
			return {
				isContentReady: false,
			}
		},
		computed: {
			app(){
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []

				//classes.push('new_class')

				return classes
			},
			doc(){
				return this.app.doc
			},
		},
		methods: {},
		mounted(){
			this.isContentReady = true

			// der edit view kann nur aufgerufen werden,
			// wenn es bereits dataRows im doc gibt.
			// die befüllung des docs findet im HomeView
			// via file-select oder csv-upload statt.
			if( !this.doc.countDataRows ){
				this.$router.push({ name: 'HomeView' })
			}
		},
	}
</script>

<style lang="less">
	@import (reference) "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";

	.EditView {}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
